import { useEffect, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Col, Grid, InputMask, Line, Row, SelectForm } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import {
  ITipoMotivoBloqueio,
  MotivosBloqueioInterface
} from 'services/NGT/RecordsSheet'
import { SPACING } from 'utils'
import * as yup from 'yup'

import {
  DialogStyled,
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './EditBlockModal.style'

interface IEditBlockModal {
  showEditModal: boolean
  toggleModal: () => void
  handleSubmitUpdate: any
  blockData: MotivosBloqueioInterface
  tiposMotivoBloqueio: ITipoMotivoBloqueio[]
}

const schema = yup.object({
  tipoMotivoBloqueioId: yup.number().required('Informe tipo motivo'),
  txDescricao: yup.string().required('Informe a descrição'),
  txMotivo: yup.string().required('Informe o motivo')
})

const EditBlockModal: React.FC<IEditBlockModal> = ({
  showEditModal,
  toggleModal,
  handleSubmitUpdate,
  tiposMotivoBloqueio,
  blockData
}) => {
  const {
    clearErrors,
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) })

  const handleClearForm = () => {
    reset({
      txDescricao: '',
      txMotivo: ''
    })
  }

  useEffect(() => {
    setValue('txDescricao', blockData?.txDescricao)
    setValue('txMotivo', blockData?.txMotivo)
    setValue('tipoMotivoBloqueioId', blockData?.tipoMotivoBloqueioId)
  }, [blockData, showEditModal])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showEditModal}
      onClose={toggleModal}
      width={'md'}
    >
      <FormDialog
        onSubmit={handleSubmit((data) => {
          handleSubmitUpdate({
            ...data,
            idMotivoBloqueio: blockData?.idMotivoBloqueio
          })
          reset()
          handleClearForm()
          resetModalState(draggableReference)
          toggleModal()
        })}
      >
        <Line />
        <DialogTitleStyled>Editar Motivo Bloqueio</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="7fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing20} 0 ${SPACING.spacing20} 0`}
          >
            <Col gap="1.5rem">
              <InputMask
                control={control}
                errors={errors}
                label="Motivo"
                formValue="txMotivo"
                placeholder="Informe o motivo"
                maxLength={50}
                type="alfanumeric"
                required
              />
              <InputMask
                control={control}
                errors={errors}
                label="Descrição Motivo"
                formValue="txDescricao"
                placeholder="Informe a descrição"
                maxLength={100}
                type="cleanText"
                required
              />
              <SelectForm
                control={control}
                errors={errors}
                label="Tipo Motivo"
                formValue="tipoMotivoBloqueioId"
                placeholder="Selecione"
                listOptions={tiposMotivoBloqueio}
                labelMenu="txTipo"
                valueMenu="idTipoMotivoBloqueio"
              />
            </Col>
          </Grid>
        </DialogContentStyled>
        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            onClick={() => {
              clearErrors()
              toggleModal()
              resetModalState(draggableReference)
            }}
            marginBottom={SPACING.spacing15}
          />
          <Row justifyContent="flex-end">
            <Button
              text="SALVAR"
              type="submit"
              marginLeft={SPACING.spacing20}
              marginRight={SPACING.spacing20}
              marginBottom={SPACING.spacing15}
            />
          </Row>
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default EditBlockModal
